import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteLocation } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for deleting a Location.
 */
export const useDeleteLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call deletePlant.
     * @param {Pella.ProductionRequestAPI.Location['id']} id - The ID of the Location to delete.
     */
    mutationFn: (id) => deleteLocation(id),
    onSuccess: () => {
      toast.success('Location deleted successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LOCATION_DATA] });
    },
  });
};
